module.exports = __webpack_public_path__ + "media/packs/images/flags/PY-a97258a3a169f9fd054f8e111aa9d8c4.svg";